// The regulations acceptance cache lives in localStorage, and two places need
// it: the Regulations feature (read/write) and logout (clear).
//
// Keeping the key and the clear helper here is what lets `useLogout` — a
// shared hook — stop importing the Regulations feature (#33). A session-cleanup
// registry that features opt into would be tidier, but it would make the clear
// depend on the feature's module being loaded at logout time; this does not.
export const REGULATIONS_CACHE_KEY = 'regulations_accepted_cache'

export const clearRegulationsCache = () => {
    try {
        localStorage.removeItem(REGULATIONS_CACHE_KEY)
    } catch {
        // Ignore storage errors
    }
}
